import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { formatCurrencyValue } from '@eika/currency-input';

import { LaantypeWeb, SoeknadLaanContainerWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { LaanebeloepFormData } from './laanebeloep';
import { belaaningsgrad, nyttLaanebeloep, nyttMaanedligBeloep } from './laaneberegning';

interface Props {
    soeknadLaan: SoeknadLaanContainerWeb | undefined;
}

const LaaneberegningUtlaanInfo: FC<Props> = ({ soeknadLaan }) => {
    const { laanebeloep } = useTranslation();
    const { watch } = useFormContext<LaanebeloepFormData>();
    const watchAll = watch();

    return (
        <div>
            <div className="info-box row-gap margin-bottom-small">
                <span className="title">{laanebeloep.infoNyttBoliglaan}</span>
                <span>
                    <span>{`${laanebeloep.infoNyttLaanebeloep}: `}</span>
                    <span className="bold">{`${formatCurrencyValue(
                        nyttLaanebeloep(
                            soeknadLaan?.laan.eksisterendeLaanebeloep || 0,
                            Number(watchAll.soektBeloep || 0),
                        ),
                    )} kr`}</span>
                </span>
                {soeknadLaan?.laan.laantype === LaantypeWeb.UTLAAN && (
                    <>
                        <span>
                            <span>{`${laanebeloep.infoNyNebetalingstid}: `}</span>
                            <span className="bold">{`${watchAll.nedbetalingstid || 0} år`}</span>
                        </span>
                        <span>
                            <span>{`${laanebeloep.infoNyttMaanteligBeloep}: `}</span>
                            <span className="bold">{`${formatCurrencyValue(
                                nyttMaanedligBeloep(
                                    soeknadLaan?.laan.eksisterendeLaanebeloep || 0,
                                    Number(watchAll.soektBeloep || 0),
                                    soeknadLaan?.laan.rente || 4,
                                    Number(watchAll.nedbetalingstid * 12 || 0),
                                ),
                            )} kr`}</span>
                        </span>
                    </>
                )}
                {soeknadLaan?.eiendomVerdi && (
                    <span>
                        <span>{`${laanebeloep.infoBelaaningsgrad}: `}</span>
                        <span className="bold">{`${belaaningsgrad(
                            soeknadLaan?.eiendomVerdi,
                            soeknadLaan?.laan.eksisterendeLaanebeloep || 0,
                            Number(watchAll.soektBeloep || 0),
                            soeknadLaan?.andelFellesgjeld || 0,
                        )} %`}</span>
                    </span>
                )}
            </div>
        </div>
    );
};

export default LaaneberegningUtlaanInfo;
